import { useEffect, useState } from 'react';

import { USE_STATIC_SITE_CONTENT } from '../config/staticSiteMode';
import { STATIC_PROJECT_ITEMS } from '../data/staticSite/content';
import { useAuth } from '../context/AuthContext';

const DEFAULT_MAX = 10;

/**
 * CMS proje listesi — `GET /cms/Project/GetAll` (ProjectCard öğe şekli).
 * @param {{ maxItems?: number }} [opts]
 * @returns {null | Array<{ id: string, imageUrl: string, title: string, description: string, href: string }>}
 */
export function useCmsProjectItems(opts = {}) {
    const maxItems = opts.maxItems ?? DEFAULT_MAX;
    const { authToken } = useAuth();
    const [items, setItems] = useState(
        /** @type {null | typeof STATIC_PROJECT_ITEMS} */
        (USE_STATIC_SITE_CONTENT ? STATIC_PROJECT_ITEMS : null),
    );

    useEffect(() => {
        if (USE_STATIC_SITE_CONTENT) {
            setItems(STATIC_PROJECT_ITEMS.slice(0, maxItems));
            return undefined;
        }

        let cancelled = false;

        /*
        (async () => {
            try {
                const raw = await fetchCmsProjectsList({
                    pageNumber: 1,
                    pageSize: maxItems,
                    accessToken: authToken,
                });
                const mapped = raw
                    .map(mapCmsProjectToCardItem)
                    .filter((x) => x.imageUrl);
                if (!cancelled) {
                    setItems(mapped.slice(0, maxItems));
                }
            } catch {
                if (!cancelled) {
                    setItems([]);
                }
            }
        })();
        */

        return () => {
            cancelled = true;
        };
    }, [authToken, maxItems]);

    return items;
}
